import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { httpPost } from "../../../../common/httpCall";

const TractionAIRecommend = () => {
  const dispatch = useDispatch();

  const [fetchingRes, setFetchingRes] = useState(false);
  const [response, setResponse] = useState(null);

  const {
    authReducer: { session },
    councilReducer: { selectedCouncil },
  } = useSelector((state) => state);

  const handleOptionSelect = prompt => {
    setFetchingRes(true);
    httpPost({
      call: 'ai/proxy/endpoints',
      data: {
        endpoint: "recommend",
        prompt,
      }
    }).subscribe(res => {
      if (res.response.body) {
        setResponse(res.response.body)
      }
      console.log('res', res);
      setFetchingRes(false);
    });
  }

  return (
    <div>
      recommend screen stuff
    </div>
  );
};

export default React.memo(TractionAIRecommend);
